var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Vcode',{attrs:{"imgs":_vm.imageList,"show":_vm.capShow},on:{"success":_vm.onSuccess,"close":_vm.onClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }